"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShowAllSwitch = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CSwitch = _interopRequireDefault(require("../../components/materials/CSwitch"));
var _labelConsts = require("../../constants/labelConsts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 全て表示切替ヘッダ部品
 * @prop {bool} showAll - 全て表示フラグ
 * @prop {func} changeShowAll - 全て表示変更関数
 * @prop {string} labelText - ラベル表示テキスト（変更したい場合のみ）<br/>
 * シグネチャ:(showAll:bool):void
 */
const ShowAllSwitch = props => {
  const {
    intl,
    showAll,
    changeShowAll,
    labelText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
    label: labelText ? labelText : intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SHOW_ALL
    }),
    checked: showAll,
    onChange: changeShowAll,
    shiftLeft: true
  });
};
exports.ShowAllSwitch = ShowAllSwitch;
ShowAllSwitch.propTypes = {
  showAll: _propTypes.default.bool.isRequired,
  changeShowAll: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)(ShowAllSwitch);